import * as React from 'react';

const SvgViewSiteMapOutline = (props) => (
  <svg
    id='ViewSiteMapOutline_svg__Layer_2'
    data-name='Layer 2'
    xmlns='http://www.w3.org/2000/svg'
    width={'1.15em'}
    height={'1.15em'}
    viewBox='24 24 82 82'
    {...props}
  >
    <defs>
      <style>{'.ViewSiteMapOutline_svg__cls-1{fill:currentColor}'}</style>
    </defs>
    <g id='ViewSiteMapOutline_svg__Layer_1-2' data-name='Layer 1'>
      <g id='ViewSiteMapOutline_svg__b'>
        <path
          className='ViewSiteMapOutline_svg__cls-1'
          d='M103.52 57.5c-6-6.38-18.92-17.06-38.35-17.06S32.98 51 27.03 57.29c-4.01 4.22-4.01 10.64 0 14.91 5.96 6.29 18.88 16.85 38.14 16.85s32.36-10.69 38.35-17.06c3.89-4.14 3.89-10.35 0-14.49Zm-4.6 10.14c-5.28 5.62-16.68 15.04-33.71 15.04s-28.26-9.33-33.54-14.87c-1.69-1.77-1.69-4.39 0-6.17 5.28-5.53 16.64-14.87 33.54-14.87s28.43 9.42 33.71 15.04c1.56 1.65 1.56 4.14 0 5.79v.04Z'
        />
        <path
          className='ViewSiteMapOutline_svg__cls-1'
          d='M65.21 53.1c-6.42 0-11.62 5.2-11.62 11.62s5.2 11.62 11.62 11.62 11.62-5.2 11.62-11.62-5.2-11.62-11.62-11.62Zm0 16.9c-2.91 0-5.28-2.37-5.28-5.28s2.37-5.28 5.28-5.28 5.28 2.37 5.28 5.28S68.12 70 65.21 70Z'
        />
      </g>
    </g>
  </svg>
);
export default SvgViewSiteMapOutline;
